import { render, staticRenderFns } from "./dr-error.vue?vue&type=template&id=033c1a3c"
import script from "./dr-error.vue?vue&type=script&lang=js"
export * from "./dr-error.vue?vue&type=script&lang=js"
import style0 from "./dr-error.vue?vue&type=style&index=0&id=033c1a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports